import React from 'react';
import Card, { CardBody, CardHeader } from './Card';
import cx from './cx';

/**
 * TableCard composition rules
 *
 * - TableCard is a list layout container only.
 * - Use only toolbar/table/pagination slots for composition.
 * - Render modals and overlays at page level (outside TableCard).
 *
 * Why:
 * - Overlay components (modal/backdrop/portal layers) need predictable stacking
 *   and should not depend on list container structure.
 * - Keeping TableCard focused on layout preserves separation of concerns:
 *   list structure here, interactions/overlays in page-level orchestration.
 */
function TableCard({
  header,
  toolbar,
  table,
  pagination,
  children,
  className,
  bodyClassName,
  toolbarClassName,
  tableClassName,
  paginationClassName,
  ...props
}) {
  const tableContent = table || children;

  return (
    <Card className={cx('rg-table-card', className)} {...props}>
      {header ? <CardHeader>{header}</CardHeader> : null}
      <CardBody className={cx('rg-table-card__body', bodyClassName)}>
        {toolbar ? (
          <div className={cx('rg-table-card__toolbar', toolbarClassName)}>{toolbar}</div>
        ) : null}

        <div className={cx('rg-table-wrap', tableClassName)}>{tableContent}</div>

        {pagination ? (
          <div className={cx('rg-table-card__pagination', paginationClassName)}>
            {pagination}
          </div>
        ) : null}
      </CardBody>
    </Card>
  );
}

export default TableCard;
